import { createFileRoute } from "@tanstack/react-router";

import { ThemesPage } from "../../../features/storefront/themes-page";

export const Route = createFileRoute("/_app/settings/themes")({ component: ThemesPage });
